import request from '../request';

//条件查询
export const reqGetPageData = (data) => request({ url:'/admin/tableCode', method:'get', params:data });

//生成二维码
export const reqGetQcCode = (data) => request({ url:'/admin/qrCode', method:'get', params:data });

//删除
export const reqDeleteData = (id) => request({ url:`/admin/qrCode/delete/${id}`, method:'delete'});
